"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var API_1 = __importDefault(require("../lib/API"));
;
var PostType = /** @class */ (function (_super) {
    __extends(PostType, _super);
    function PostType(props) {
        var _this = _super.call(this, props) || this;
        _this.timer = null;
        _this.timerDuration = 1000;
        _this.setSearchText = function (searchText) {
            clearTimeout(_this.timer);
            _this.setState({
                searchTerm: searchText,
                page: 1,
                loading: true,
            }, function () {
                _this.timer = setTimeout(function () {
                    _this.getMaxPosts();
                    _this.getPosts();
                }, _this.timerDuration);
            });
        };
        _this.setCategory = function (categoryValue, categoryName) {
            var _a;
            clearTimeout(_this.timer);
            console.log("Category Value: " + categoryValue);
            var category = {
                name: categoryName,
                id: categoryValue,
            };
            var currentCategories = (_a = _this.state.selectedCategories) !== null && _a !== void 0 ? _a : new Array();
            if (currentCategories) {
                var found_1 = false;
                currentCategories.forEach(function (cat, i) {
                    if (cat.name === categoryName) {
                        if (categoryValue === -1) {
                            currentCategories.splice(i, 1);
                        }
                        else {
                            currentCategories[i] = category;
                        }
                        /* Adding this as if only 1 category is selected and that is 'All' a.k.a. -1 then this throws an
                        arrow as it's spliced in the lines prior */
                        if (currentCategories.length !== 0) {
                            found_1 = true;
                        }
                    }
                });
                if (!found_1) {
                    currentCategories.push(category);
                }
            }
            else {
                currentCategories.push(category);
            }
            console.log("Updating categories: ", currentCategories);
            _this.setState({
                selectedCategories: currentCategories,
                page: 1,
                loading: true,
            }, function () {
                _this.timer = setTimeout(function () {
                    _this.getMaxPosts();
                    _this.getPosts();
                }, _this.timerDuration);
            });
        };
        _this.convertHTMLEntity = function (encodedString) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = encodedString;
            var value = textArea.value;
            textArea.remove();
            return value;
        };
        _this.setPage = function (page) {
            _this.setState({
                page: page,
                loading: true,
            }, function () {
                _this.getPosts();
            });
            console.log("Changing page to: " + page);
        };
        _this.getIndustries = function (postType) { return __awaiter(_this, void 0, void 0, function () {
            var base, url, response, categories, categoryIds, categoryObj;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        base = window.location.origin;
                        url = new URL((_a = "/wp-json/queries/industry-list?postType=" + postType) !== null && _a !== void 0 ? _a : this.props.postType, base);
                        return [4 /*yield*/, fetch(url.toString())];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        categories = _b.sent();
                        console.log("Insights: ", categories);
                        if (!categories.success) {
                            return [2 /*return*/];
                        }
                        categoryIds = [];
                        if (categories && categories.terms) {
                            categories.terms.forEach(function (term) {
                                if (term.name && term.term_id) {
                                    var id = term.term_id;
                                    var name_1 = term.name;
                                    name_1 = _this.convertHTMLEntity(name_1);
                                    // name = name.replace("&#038;", "&");
                                    if (name_1 !== "Uncategorized") {
                                        categoryIds.push({
                                            label: name_1,
                                            value: id,
                                        });
                                    }
                                }
                            });
                            categoryObj = {
                                name: 'industry-category',
                                ids: categoryIds,
                                type: 'dropdown',
                            };
                            console.log("Previous categories: ", this.state.categories);
                            if (categoryIds && categoryIds.length > 0) {
                                console.log("New category", categoryObj);
                                this.setState({
                                    categories: __spreadArray(__spreadArray([], this.state.categories, true), [categoryObj], false)
                                });
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getCategories = function (categoryName, type) { return __awaiter(_this, void 0, void 0, function () {
            var base, url, response, categories, categoryIds, categoryObj;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = window.location.origin;
                        url = new URL("/wp-json/wp/v2/" + categoryName, base);
                        url.searchParams.append('hide_empty', "true");
                        return [4 /*yield*/, fetch(url.toString())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        categories = _a.sent();
                        console.log("Response: ", categories);
                        categoryIds = [];
                        categories.forEach(function (category) {
                            if ((category.name || category.title) && category.id) {
                                var id = category.id;
                                var name_2 = (category.name) ? category.name : category.title.rendered;
                                name_2 = _this.convertHTMLEntity(name_2);
                                if (name_2 !== "Uncategorized") {
                                    categoryIds.push({
                                        label: name_2,
                                        value: id,
                                    });
                                }
                            }
                        });
                        categoryObj = {
                            name: categoryName,
                            ids: categoryIds,
                            type: type,
                        };
                        console.log("Previous categories: ", this.state.categories);
                        if (categoryIds && categoryIds.length > 0) {
                            console.log("New category", categoryObj);
                            this.setState({
                                categories: __spreadArray(__spreadArray([], this.state.categories, true), [categoryObj], false)
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getMaxPosts = function () { return __awaiter(_this, void 0, void 0, function () {
            var totals;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.default.getPostsTotal(this.props.postType, {
                            per_page: this.state.postsPerPage,
                            categories: this.state.selectedCategories,
                            page: 1,
                            search: this.state.searchTerm,
                            orderby: this.props.orderby,
                            order: this.props.order,
                        })];
                    case 1:
                        totals = _a.sent();
                        console.log("Totals: ", totals);
                        this.setState({
                            pageCount: totals.totalPages,
                            postCount: totals.totalPosts,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getPosts = function () { return __awaiter(_this, void 0, void 0, function () {
            var posts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.default.getPosts(this.props.postType, {
                            categories: this.state.selectedCategories,
                            search: this.state.searchTerm,
                            page: this.state.page,
                            per_page: this.state.postsPerPage,
                            orderby: this.props.orderby,
                            order: this.props.order,
                        })];
                    case 1:
                        posts = _a.sent();
                        // const posts = await response.json();
                        console.log("Posts: ", posts);
                        this.setState({
                            posts: posts,
                            loading: false,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            posts: [],
            categories: [],
            searchTerm: "",
            selectedCategories: _this.props.selectedCategories,
            postsPerPage: _this.props.postsPerPage,
            page: 1,
            loading: true,
        };
        return _this;
    }
    PostType.defaultProps = {
        postsPerPage: 10,
        postType: "posts",
        orderby: "date",
        order: "desc",
        includeIndustry: false,
        selectedCategories: null,
    };
    return PostType;
}(react_1.default.Component));
exports.default = PostType;
